import { render, staticRenderFns } from "./DeleteNotificationModal.vue?vue&type=template&id=ee0f5d36&scoped=true"
import script from "./DeleteNotificationModal.vue?vue&type=script&lang=js"
export * from "./DeleteNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteNotificationModal.vue?vue&type=style&index=0&id=ee0f5d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0f5d36",
  null
  
)

export default component.exports